import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${props => props.theme.colors.primaryBackground};

  .header {
    border-bottom: 1px #707070 solid;
    padding-bottom: 20px;

    h1 {
      font-size: 2.8rem;
      color: ${props => props.theme.colors.primaryText};
      margin: 0 0 40px 0;
    }

    .login-information {
      & > * {
        margin: 0 20px 30px 0;
      }

      .TextField-lgpd {
        width: 100%;
        max-width: 300px;

        > label {
          color: ${props => props.theme.colors.primaryText};
          font-size: 1.4rem;
        }

        .MuiInputBase-root {
          font-size: 1.4rem;

          input {
            color: ${props => props.theme.colors.primaryText};
            font-size: 1.4rem;
          }
          fieldset {
            border-color: #929292;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    padding: 0;

    .MuiFormControl-root {
      border-bottom: 1px #707070 solid;
      padding-bottom: 20px;
      width: 100%;

      .MuiFormGroup-root {
        flex-direction: row;
        color: ${props => props.theme.colors.primaryText};

        .PrivateRadioButtonIcon-checked-266 {
          color: #136edb !important;
        }

        .PrivateRadioButtonIcon-root-264 {
          color: ${props => props.theme.colors.primaryText};
        }

        .MuiTypography-root {
          font-size: 1.6rem;
        }
      }
    }

    h2 {
      color: ${props => props.theme.colors.primaryText};
      font-size: 2rem;
      margin: 30px 0 30px;
    }

    .table-lgpd {
      .MuiTablePagination-selectRoot {
        display: none;
      }

      .MuiPaper-root {
        background-color: ${props => props.theme.colors.primaryBackground};
        border: 1px solid #707070;

        .MuiTableHead-root {
          .MuiButtonBase-root {
            font-size: 1.4rem;
            color: ${props => props.theme.colors.primaryText};
          }

          .MuiSvgIcon-root {
            color: ${props => props.theme.colors.primaryText} !important;
          }
        }

        .MuiTableBody-root {
          .MuiTableCell-root {
            font-size: 1.2rem;
          }

          .MuiTableCell-body {
            color: ${props => props.theme.colors.primaryText};
          }

          .Mui-selected {
            background-color: rgba(0, 69, 245, 0.08);
          }

          .MuiCheckbox-root {
            color: ${props => props.theme.colors.primaryText};
          }

          .Mui-checked {
            color: #136edb !important;
          }

          .MuiButtonBase-root {
            &:hover {
              background-color: rgba(0, 69, 245, 0.08);
            }
          }
        }
      }
    }

    .MuiTablePagination-root {
      color: ${props => props.theme.colors.primaryText};

      .MuiTypography-root {
        font-size: 1.2rem;
      }

      .MuiSelect-root {
        font-size: 1.2rem;
      }

      .MuiSvgIcon-root {
        color: ${props => props.theme.colors.primaryText};
      }
    }
  }

  .ReCAPTCHA {
    margin-top: 20px;
  }

  .modal-dialog {
    .modal-header {
      position: relative;

      .modal-title {
        font-size: 2.6rem;
      }

      button {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 50px;
        height: 50px;
      }
    }

    .modal-body {
      padding: 15px 15px 25px;
    }
  }

  .buttons {
    margin: 40px 0;

    .help {
      background: none;
      border: 1px solid ${props => props.theme.colors.primaryText};
      margin-right: 30px;

      & .MuiButton-label {
        color: ${props => props.theme.colors.primaryText};
      }
    }
  }
`;

export const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
  padding: 7px 14px;
  border-radius: 24px !important;
  height: 40px;
  width: 120px;
  & .MuiButton-label {
    color: #fff;
  }
`;
